import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { CheckCircle } from "lucide-react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import silverFox from './../assets/images/Weddings/SilverFox/silverFox.webp'
import grayFox from './../assets/images/Weddings/GrayFox/grayFox.png'
import grandAfternoonTea from './../assets/images/Weddings/GrandAfternoonTea/grandAfternoonTea.png'
import fennecFox from './../assets/images/Weddings/FennecFox/fennecFox.png'
import silverFox1 from './../assets/images/Weddings/SilverFox/slide1.webp'
import silverFox2 from './../assets/images/Weddings/SilverFox/slide2.webp'
import silverFox3 from './../assets/images/Weddings/SilverFox/slide3.webp'
import silverFox4 from './../assets/images/Weddings/SilverFox/slide4.webp'
import silverFox5 from './../assets/images/Weddings/SilverFox/slide5.webp'
import silverFox6 from './../assets/images/Weddings/SilverFox/slide6.webp'
import grayFox1 from './../assets/images/Weddings/GrayFox/slide1.webp'
import grayFox2 from './../assets/images/Weddings/GrayFox/slide2.webp'
import grayFox3 from './../assets/images/Weddings/GrayFox/slide3.webp'
import grayFox4 from './../assets/images/Weddings/GrayFox/slide4.webp'
import afternoonTea1 from './../assets/images/Weddings/GrandAfternoonTea/slide1.webp'
import afternoonTea2 from './../assets/images/Weddings/GrandAfternoonTea/slide2.webp'
import afternoonTea3 from './../assets/images/Weddings/GrandAfternoonTea/slide3.webp'
import afternoonTea4 from './../assets/images/Weddings/GrandAfternoonTea/slide4.webp'
import afternoonTea5 from './../assets/images/Weddings/GrandAfternoonTea/slide5.webp'
import afternoonTea6 from './../assets/images/Weddings/GrandAfternoonTea/slide6.webp'
import fennecFox1 from './../assets/images/Weddings/FennecFox/slide1.webp'
import fennecFox2 from './../assets/images/Weddings/FennecFox/slide2.webp'
import fennecFox3 from './../assets/images/Weddings/FennecFox/slide3.webp'
import fennecFox4 from './../assets/images/Weddings/FennecFox/slide4.webp'
import fennecFox5 from './../assets/images/Weddings/FennecFox/slide5.webp'

const packages = [
    {
      name: "The Silver Fox Package",
      logo: silverFox,
      description:
      "Our premium 5-star offering, providing everything you need for your special day, including a luxurious 3-course sit-down meal and an evening banquet.",
    inclusions: [
      "Dedicated Wedding Executive to help plan your day",
      "Arrival / After ceremony drinks for all your daytime guests (choice of 2 plus non-alcoholic option)",
      "Master of Ceremonies to ensure a stress-free day",
      "White linen tablecloths, all glassware & cutlery",
      "Cake stand & silver cake knife",
      "Chiavari chairs & colour-coordinated sashes (supplements apply to non-standard chair decor)",
      "Vintage Post Box & Easel for table plan display",
      "3-Course Sit-Down Meal (including canapés, mains & desserts)",
      "Separate children's menu available",
      "A glass of Prosecco to toast for all your wedding party",
      "1 medium glass of wine per guest with the wedding breakfast",
      "Evening buffet to include either our whole hog roast (100+) or a choice of two options from our street food menu",
      "Additional evening-only guests are charged between £15 - £20 per head depending on your choices",
      "DJ for evening entertainment",
      "Extended bar service until 12:30 AM",
      "Overnight stay for the night of the wedding including full English breakfast"
    ],
    images: [
      silverFox1,
      silverFox2,
      silverFox3,
      silverFox4,
      silverFox5,
      silverFox6
    ],
  },
  {
    name: "The Gray Fox Package",
    logo: grayFox,
    description:
      "Designed for a more casual and relaxed event, featuring a buffet-style wedding breakfast and an evening banquet.",
    inclusions: [
        "Dedicated Wedding Executive to help plan your day",
        "Arrival / After ceremony drinks for all your daytime guests (choice of 2 plus non-alcoholic option)",
        "Master of Ceremonies to ensure a stress-free day",
        "White linen tablecloths, all glassware & cutlery",
        "Cake stand and silver cake knife",
        "Chiavari chairs & colour-coordinated sashes (supplements apply to non-standard chair decor)",
        "Plated BBQ served buffet style (option to serve to tables for a maximum of 70 guests with a £5 per head supplement)",
        "Separate children's menu available",
        "A glass of Prosecco to toast for all your wedding party",
        "Evening buffet to include either our whole hog roast (100+) or a choice of two options from our street food menu",
        "Additional evening only guests are charged between £15 - £20 per head depending on your choices",
        "DJ for evening entertainment",
        "Extended bar service until 12:30 AM",
        "Overnight stay for the night of the wedding including full English breakfast"
    ],
    images: [
      grayFox1,
      grayFox2,
      grayFox3,
      grayFox4
    ],
  },
  {
    name: "The Grand Afternoon Tea Package",
    logo: grandAfternoonTea,
    description:
      "Offering an elegant, vintage-style wedding breakfast, served on stands at each table. It's sure to look as delightful as it tastes",
    inclusions: [
        "Dedicated Wedding Executive to help plan your day",
        "Arrival / After ceremony drinks for all your daytime guests (choice of 2 plus non-alcoholic option)",
        "Master of Ceremonies to ensure a stress-free day",
        "White linen tablecloths, all glassware & cutlery",
        "Cake stand and silver cake knife",
        "Chiavari chairs & colour-coordinated sashes (supplements apply to non-standard chair decor)",
        "Optional use of either Silver Candelabras for tables (8 max)",
        "A selection of finger sandwiches of your choice",
        "A scrumptious variety of seasonal sweet treats to include traditional scones with strawberry jam and Cornish clotted cream",
        "Assortment of teas",
        "All vintage-style cake stands, teapots, crockery etc.",
        "Separate children's menu available",
        "A glass of Prosecco to toast for all your wedding party",
        "Evening buffet to include either our whole hog roast (100+) or a choice of two options from our street food menu",
        "Additional evening-only guests are charged between £15 - £20 per head depending on your choices",
        "DJ for evening entertainment",
        "Extended bar service until 12:30 AM",
        "Overnight stay for the night of the wedding including full English breakfast"
    ],
    images: [
      afternoonTea1,
      afternoonTea2,
      afternoonTea3,
      afternoonTea4,
      afternoonTea5,
      afternoonTea6
    ],
  },
  {
    name: "The Fennec Fox Package",
    logo: fennecFox,
    description:
      "Perfect for couples planning a later ceremony, after 3:30 pm. It includes after-ceremony drinks, canapés, and a delicious early evening hog roast for all your guests.",
    inclusions: [
        "Available for ceremonies after 3:30 PM",
        "Dedicated Wedding Executive to help plan your day",
        "Arrival / After ceremony drinks for all your daytime guests (choice of 2 plus non-alcoholic option)",
        "Master of Ceremonies to ensure a stress-free day",
        "White linen tablecloths, all glassware & cutlery",
        "Cake stand and silver cake knife",
        "Chiavari chairs & colour-coordinated sashes (supplements apply to non-standard chair decor)",
        "Optional use of a large overhead projector screen",
        "Canapés for all daytime guests (choice of 4)",
        "Separate children's menu available",
        "A glass of Prosecco to toast for all your wedding party",
        "Evening buffet to include either our whole hog roast (100+) or a choice of two options from our street food menu",
        "Additional evening-only guests are charged between £15 - £20 per head depending on your choices",
        "DJ for evening entertainment",
        "Extended bar service until 12:30 AM",
        "Overnight stay for the night of the wedding including full English breakfast"
    ],
    images: [
      fennecFox1,
      fennecFox2,
      fennecFox3,
      fennecFox4,
      fennecFox5
    ],
  },
];

const WeddingPackages = () => {
  return (
    <div className="max-w-[1700px] mx-auto p-6">
      <h2 className="text-4xl font-semibold tracking-widest text-pretty text-center text-gray-900 sm:text-5xl">Our Wedding Packages</h2>
      <div className="space-y-12">
        {packages.map((pkg, index) => (
          <div key={index} className="bg-white shadow-lg rounded-xl p-6">
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-6">
              <img src={pkg.logo} alt={pkg.name} className="w-24 h-24 object-contain" />
              <div>
                <h3 className="text-2xl font-semibold">{pkg.name}</h3>
                <p className="text-gray-600">{pkg.description}</p>
              </div>
            </div>

            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              navigation
              pagination={{ clickable: true }}
              className="rounded-lg overflow-hidden mb-6"
            >
              {pkg.images.map((img, i) => (
                <SwiperSlide key={i}>
                  <img src={img} alt={`Slide ${i + 1}`} className="w-full h-80 object-cover" />
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {pkg.inclusions.map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-green-500 w-5 h-5 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">{item}</span>
                    </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeddingPackages;